import "./OpenSource.scss";

import { useTranslation } from "react-i18next";

import GridBackground from "../../../components/GridBackground/GridBackground";
import Section from "../../../components/Section/Section";
import SectionHeader from "../../../components/SectionHeader/SectionHeader";
import OpenSourceCard from "./OpenSourceCard/OpenSourceCard";

const PROJECT_URLS: Record<string, string> = {
  juneogo: "https://github.com/Juneo-io/juneogo",
  juneojs: "https://github.com/Juneo-io/juneojs",
};

const OpenSource = () => {
  const { t } = useTranslation();

  const projects = t("opensource.projects", { returnObjects: true }) as Array<{
    name: string;
    badge: string;
    description: string;
    tags: string[];
    link_text: string;
  }>;

  return (
    <Section id="opensource" className="openSource">
      <GridBackground />
      <SectionHeader
        tag={t("opensource.tag")}
        title={t("opensource.title")}
        subtitle={t("opensource.subtitle")}
      />
      <div className="osGrid fi">
        {projects.map((project) => (
          <OpenSourceCard
            key={project.name}
            name={project.name}
            badge={project.badge}
            description={project.description}
            tags={project.tags}
            linkText={project.link_text}
            url={
              PROJECT_URLS[project.name.toLowerCase()] ||
              "https://github.com/Juneo-io"
            }
          />
        ))}
      </div>
    </Section>
  );
};

export default OpenSource;
